import React from 'react';
import { Building, Briefcase, Clock, List } from 'lucide-react';
import { InterviewDetails } from '../../types/interviews';
import { DurationDisplay } from '../common/DurationDisplay';
import CompanyLogo from '../common/CompanyLogo';

interface InterviewDetailsCardProps {
  interviewDetails: InterviewDetails;
}

const InterviewDetailsCard: React.FC<InterviewDetailsCardProps> = ({ interviewDetails }) => {
  return (
    <div className="bg-background-light/70 dark:bg-background-dark/70 rounded-xl p-4 border border-border-light dark:border-border-dark mb-4">
      <h2 className="font-heading font-semibold text-lg text-text-primary-light dark:text-text-primary-dark mb-3">
        {interviewDetails.title}
      </h2>
      
      <div className="space-y-2 mb-3">
        {interviewDetails.company && (
          <div className="flex items-center text-sm">
            {interviewDetails.companyLogo ? (
              <CompanyLogo 
                src={interviewDetails.companyLogo} 
                alt={interviewDetails.company}
                className="w-4 h-4 mr-2 object-contain"
                fallbackIconSize={14}
              />
            ) : (
              <Building className="w-4 h-4 mr-2 text-primary-light dark:text-primary-dark" />
            )}
            <span className="text-text-secondary-light dark:text-text-secondary-dark">
              {interviewDetails.company}
            </span>
          </div>
        )}
        
        {interviewDetails.jobRole && (
          <div className="flex items-center text-sm">
            <Briefcase className="w-4 h-4 mr-2 text-primary-light dark:text-primary-dark" />
            <span className="text-text-secondary-light dark:text-text-secondary-dark">
              {interviewDetails.jobRole}
            </span>
          </div>
        )}
        
        {/* Duration display hidden as it can be confusing for users
        {interviewDetails.duration && (
          <DurationDisplay 
            minutes={interviewDetails.duration}
            variant="inline"
            clockSize={16}
            className="text-sm"
          />
        )} */}
        
        {interviewDetails.series && (
          <div className="flex items-center text-sm">
            <List className="w-4 h-4 mr-2 text-primary-light dark:text-primary-dark" />
            <span className="text-text-secondary-light dark:text-text-secondary-dark">
              Series: {interviewDetails.series.name}
            </span>
          </div>
        )}
      </div>
      
      {interviewDetails.description && (
        <p className="text-sm text-text-secondary-light dark:text-text-secondary-dark border-t border-border-light dark:border-border-dark pt-3">
          {interviewDetails.description.length > 180 ? interviewDetails.description.slice(0, 180) + '...' : interviewDetails.description}
        </p>
      )}
    </div>
  );
};

export default InterviewDetailsCard; 